import { Component, OnInit,ViewChild  } from '@angular/core';
import { Router } from '@angular/router';
import { BaseApiService } from '../base-api.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-upload-master',
  templateUrl: './upload-master.component.html',
  styleUrls: ['./upload-master.component.css']
})

export class UploadMasterComponent implements OnInit {
  @ViewChild('form') form;
  files: FileList;
  selectedCategory: string;
  myInputVariable: any;

  constructor(private router: Router, private baseAPI: BaseApiService, private spinnerService: Ng4LoadingSpinnerService) {
    var token = localStorage.getItem('token');
    if (token == undefined || token === '') {
      this.router.navigate(['/login']);
    }
  }

  ngOnInit() {
    var token = localStorage.getItem('token');
    if (token == undefined || token === '') {
      this.router.navigate(['/login']);
    }
    this.selectedCategory = "No Category choosen";

  }
  viewMaster(){
    this.router.navigate(['/viewMaster']);
  }
  dashboard(){
    this.router.navigate(['/dashboard']);
  }
  notification(){
    this.router.navigate(['/notification']);
  }
  userPositions(){
    this.router.navigate(['/userPosition']);
  }
  category = [
    { index: '1', viewValue: 'Probing Data' },
    { index: '2', viewValue: 'Circular Data' },
    { index: '3', viewValue: 'Warranty & Service schedule Data' },
    { index: '4', viewValue: 'Product estimate EW' },
    { index: '5', viewValue: 'Product estimate AMC Silver' },
    { index: '6', viewValue: 'Product estimate AMC Gold' },
    { index: '7', viewValue: 'Product estimate AMC P2P' },
    { index: '8', viewValue: 'NSD Data' },
    { index: '9', viewValue: 'Schedule service estimator Labour data ' },
    { index: '10', viewValue: 'Schedule service estimator Part data ' },
    { index: '11', viewValue: 'Add on Job estimate Labour data' },
    { index: '12', viewValue: 'Add on Job estimate Part data' },
    { index: '13', viewValue: 'Product estimate AMC Protect Plus' }

  ];
  submit() {
    if (this.selectedCategory != undefined && this.selectedCategory != null) {
      if (this.selectedCategory === 'No Category choosen') {
        alert('Select upload category');
      }
      else {
        if (this.files != undefined && this.files != null) {
          if (this.selectedCategory === this.category[0].viewValue) {
            this.spinnerService.show();
            this.callProbingDataApi();
          }
          else if (this.selectedCategory === this.category[1].viewValue) {
            this.spinnerService.show();
            this.callCircularDataApi();
          }
          else if (this.selectedCategory === this.category[2].viewValue) {
            this.spinnerService.show();
            this.callWarrentyDataApi();
          }
          else if (this.selectedCategory === this.category[3].viewValue) {
            this.spinnerService.show();
            this.callEwDataApi();
          }
          else if (this.selectedCategory === this.category[4].viewValue) {
            this.spinnerService.show();
            this.callAMCSilverApi();
          }
          else if (this.selectedCategory === this.category[5].viewValue) {
            this.spinnerService.show();
            this.callAMCGoldApi();
          }
          else if (this.selectedCategory === this.category[6].viewValue) {
            this.spinnerService.show();
            this.callAMCP2PApi();
          }
          else if (this.selectedCategory === this.category[7].viewValue) {
            this.spinnerService.show();
            this.callNSDDataApi();
          }
          else if (this.selectedCategory === this.category[8].viewValue) {
            this.spinnerService.show();
            this.callSechduleLabourApi();
          }
          else if (this.selectedCategory === this.category[9].viewValue) {
            this.spinnerService.show();
            this.callSechdulePartApi();
          }
          else if (this.selectedCategory === this.category[10].viewValue) {
            this.spinnerService.show();
            this.callJobLabourApi();
          }
          else if (this.selectedCategory === this.category[11].viewValue) {
            this.spinnerService.show();
            this.callJobPartApi();          
          }else if (this.selectedCategory === this.category[12].viewValue) {
            this.spinnerService.show();
            this.callAMCProtectPlusApi();
          }         

        }
        else {
          alert('Choose file to upload');
        }
      }

    }
    else {

      alert('Select upload category');
    }


  }
  getFiles(event) {
    this.files = event.target.files;
    if (this.files != undefined && this.files != null) {
      var fileSize = this.files[0].size;
      if (fileSize >= 5242880) {
        alert('Please select a file below 5MB');
        this.refreshPage();
      }
    }

  }
  listClick(event: any, newValue) {
    event.preventDefault();
   // console.log(newValue);
    this.selectedCategory = newValue;

  }
  //============================API===================================================================
 
 refreshPage(){
  this.selectedCategory = "No Category choosen";
  this.files=null;
  this.form.nativeElement.reset();
 }
 
  callProbingDataApi() {
    let formData: FormData = new FormData();
    formData.append('files', this.files[0]);
    this.baseAPI.callUploadDataApi(formData, this.baseAPI.probingURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));
      var msg = jsonObj.message;
      alert(msg);
    //  console.log('Success' + JSON.stringify(data));
   this.refreshPage();
    }, (err) => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));

      alert(jsonObj.msg);
    });
  
  }
  callWarrentyDataApi() {
    let formData: FormData = new FormData();
    formData.append('files', this.files[0]);
    this.baseAPI.callUploadDataApi(formData, this.baseAPI.warrantyURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));
      var msg = jsonObj.message;
      alert(msg);
     // console.log('Success' + JSON.stringify(data));
     this.refreshPage();
    }, (err) => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));

      alert(jsonObj.msg);
    });
  }
  callNSDDataApi() {
    let formData: FormData = new FormData();
    formData.append('files', this.files[0]);
    this.baseAPI.callUploadDataApi(formData, this.baseAPI.nsdURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));
      var msg = jsonObj.message;
      alert(msg);
     // console.log('Success' + JSON.stringify(data));
     this.refreshPage();
    }, (err) => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));

      alert(jsonObj.msg);
    });
  }
  callEwDataApi() {
    let formData: FormData = new FormData();
    formData.append('files', this.files[0]);
    this.baseAPI.callUploadDataApi(formData, this.baseAPI.ewURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));
      var msg = jsonObj.message;
      alert(msg);
     // console.log('Success' + JSON.stringify(data));
     this.refreshPage();
    }, (err) => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));

      alert(jsonObj.msg);
    });
  }
  callAMCSilverApi() {
    let formData: FormData = new FormData();
    formData.append('files', this.files[0]);
    formData.append('amc_type', 'silver');
    this.baseAPI.callUploadDataApi(formData, this.baseAPI.amcURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));
      var msg = jsonObj.message;
      alert(msg);
      //console.log('Success' + JSON.stringify(data));
      this.refreshPage();
    }, (err) => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));

      alert(jsonObj.msg);
    });
  }
  callAMCGoldApi() {
    let formData: FormData = new FormData();
    formData.append('files', this.files[0]);
    formData.append('amc_type', 'gold');
    this.baseAPI.callUploadDataApi(formData, this.baseAPI.amcURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));
      var msg = jsonObj.message;
      alert(msg);
      //console.log('Success' + JSON.stringify(data));
      this.refreshPage();
    }, (err) => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));

      alert(jsonObj.msg);
    });
  }
  callAMCP2PApi() {
    let formData: FormData = new FormData();
    formData.append('files', this.files[0]);
    formData.append('amc_type', 'p2p');
    this.baseAPI.callUploadDataApi(formData, this.baseAPI.amcURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));
      var msg = jsonObj.message;
      alert(msg);
      //console.log('Success' + JSON.stringify(data));
      this.refreshPage();
    }, (err) => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));

      alert(jsonObj.msg);
    });
  }
  callSechduleLabourApi() {
    let formData: FormData = new FormData();
    formData.append('files', this.files[0]);
    formData.append('service_type', 'labour');
    this.baseAPI.callUploadDataApi(formData, this.baseAPI.sechduleServiceURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));
      var msg = jsonObj.message;
      alert(msg);
      //console.log('Success' + JSON.stringify(data));
      this.refreshPage();
    }, (err) => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));

      alert(jsonObj.msg);
    });
  }
  callSechdulePartApi() {
    let formData: FormData = new FormData();
    formData.append('files', this.files[0]);
    formData.append('service_type', 'part');
    this.baseAPI.callUploadDataApi(formData, this.baseAPI.sechduleServiceURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));
      var msg = jsonObj.message;
      alert(msg);
      //console.log('Success' + JSON.stringify(data));
      this.refreshPage();
    }, (err) => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));

      alert(jsonObj.msg);
    });
  }
  callJobLabourApi() {
    let formData: FormData = new FormData();
    formData.append('files', this.files[0]);
    formData.append('std_est', 'labour');
    this.baseAPI.callUploadDataApi(formData, this.baseAPI.jobEstimateURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));
      var msg = jsonObj.message;
      alert(msg);
      //console.log('Success' + JSON.stringify(data));
      this.refreshPage();
    }, (err) => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));

      alert(jsonObj.msg);
    });
  }
  callJobPartApi() {
    let formData: FormData = new FormData();
    formData.append('files', this.files[0]);
    formData.append('std_est', 'part');
    this.baseAPI.callUploadDataApi(formData, this.baseAPI.jobEstimateURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));
      var msg = jsonObj.message;
      alert(msg);
      //console.log('Success' + JSON.stringify(data));
      this.refreshPage();
    }, (err) => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));

      alert(jsonObj.msg);
    });
  }
  callCircularDataApi(){
    let formData: FormData = new FormData();
    formData.append('files', this.files[0]);
    this.baseAPI.callUploadDataApi(formData, this.baseAPI.circularURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));
      var msg = jsonObj.message;
      alert(msg);
      //console.log('Success' + JSON.stringify(data));
      this.refreshPage();
    }, (err) => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));

      alert(jsonObj.msg);
      
    });
  }
  callAMCProtectPlusApi() {
    let formData: FormData = new FormData();
    formData.append('files', this.files[0]);
    formData.append('amc_type', 'protect_plus');
    this.baseAPI.callUploadDataApi(formData, this.baseAPI.amcURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));
      var msg = jsonObj.message;
      alert(msg);
      //console.log('Success' + JSON.stringify(data));
      this.refreshPage();
    }, (err) => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));

      alert(jsonObj.msg);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/upload-master/upload-master.component.ts